import { Navigate, Route, Routes } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Layout } from "./components/Layout";
import { CmsPageRoute } from "./components/CmsPageRenderer";
import { Calendar } from "./pages/Calendar";
import { News } from "./pages/News";
import { NewsArticle } from "./pages/NewsArticle";
import { NotFound } from "./pages/NotFound";
import { PublicForm } from "./pages/PublicForm";
import { Staff } from "./pages/Staff";
import { getCmsPage } from "./data/cms";
import { useEffect, useState } from "react";

function CustomCmsRoute() {
  const params = useParams();
  const slug = params["*"] || "";
  const [exists, setExists] = useState<boolean | null>(null);

  useEffect(() => {
    setExists(null);
    getCmsPage(slug, { useFallback: false }).then((page) => setExists(Boolean(page))).catch(() => setExists(false));
  }, [slug]);

  if (exists === null) return null;
  if (!exists) return <NotFound />;
  return <CmsPageRoute slug={slug} />;
}

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<CmsPageRoute slug="home" />} />
        <Route path="/about" element={<CmsPageRoute slug="about" />} />
        <Route path="/classical-education" element={<CmsPageRoute slug="classical-education" />} />
        <Route path="/academics" element={<CmsPageRoute slug="academics" />} />
        <Route path="/academics/preschool" element={<CmsPageRoute slug="academics/preschool" />} />
        <Route path="/academics/kindergarten" element={<CmsPageRoute slug="academics/kindergarten" />} />
        <Route path="/academics/elementary" element={<CmsPageRoute slug="academics/elementary" />} />
        <Route path="/admissions" element={<CmsPageRoute slug="admissions" />} />
        <Route path="/parents" element={<CmsPageRoute slug="parents" />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/:id" element={<NewsArticle />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/giving" element={<CmsPageRoute slug="giving" />} />
        <Route path="/support" element={<Navigate to="/giving" replace />} />
        <Route path="/staff" element={<Staff />} />
        <Route path="/contact" element={<CmsPageRoute slug="contact" />} />
        <Route path="/forms/:slug" element={<PublicForm />} />
        <Route path="/christian-school-hastings-ne" element={<CmsPageRoute slug="christian-school-hastings-ne" />} />
        <Route path="/classical-christian-school" element={<CmsPageRoute slug="classical-christian-school" />} />
        <Route path="/tuition-financial-aid" element={<CmsPageRoute slug="tuition-financial-aid" />} />
        <Route path="*" element={<CustomCmsRoute />} />
      </Routes>
    </Layout>
  );
}
